export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).filter(Boolean).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function formatNaira(n) {
  return "₦" + Number(n || 0).toLocaleString();
}

export function formatPhone(phone) {
  if (!phone) return "";
  const d = phone.replace(/\D/g, "");
  if (d.length === 11) return d.replace(/(\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
  return phone;
}

export const CATEGORY_ICONS = {
  plumbing: "Drop",
  electrical: "Lightning",
  ac_cooling: "Snowflake",
  carpentry: "Hammer",
  painting: "PaintBrush",
  tiling: "SquaresFour",
  welding: "Wrench",
  solar_power: "Sun",
  auto_services: "Car",
  cleaning: "Broom",
  interior: "Couch",
  masonry: "Wall",
};
